import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import { toast } from '@repo/toast';
import { ArrowRightIcon } from '@repo/icons';
import { Button } from '@repo/ui';

interface Props {
  testId: TestId;
  onContinueAsGuest: () => Promise<void>;
  pending?: boolean;
}

export default function GuestSection({ testId, onContinueAsGuest, pending }: Props) {
  const handleContinueAsGuest = async () => {
    if (pending) return;
    try {
      await onContinueAsGuest();
    } catch {
      toast.danger(tr('auth:login_drawer.guest.error'), testId.append('errorToast'));
    }
  };

  return (
    <>
      <h2 className="text-heading text-lg font-semibold">{tr('auth:login_drawer.guest.title')}</h2>
      <p className="text-body text-sm">{tr('auth:login_drawer.guest.description')}</p>

      <Button
        color="secondary"
        testId={testId.append('continueAsGuest')}
        onClick={handleContinueAsGuest}
        rightIcon={ArrowRightIcon}
        disabled={pending}
        pending={pending}
      >
        {tr('auth:login_drawer.guest.cta')}
      </Button>
    </>
  );
}
